'use strict';

import { XAxis, YAxis } from '../chart-services';

export function renderXAxis (xScale, xAxis, xLabel, transitionDuration) {
  const renderXAxisOptions = { translate: { x: 0, y: this.height_ } };
  if (typeof this.rotateX === 'number') {
    renderXAxisOptions.rotate = this.rotateX;
  }
  if (['vertical', 'grouped'].includes(this.barOrientation) && this.isWrapX === true) {
    renderXAxisOptions.ellipsis = { width: this.rotateX ? this.margin.bottom : xScale.bandwidth() };
  }
  if (xLabel !== undefined) {
    renderXAxisOptions.label = {
      fontStyle: this.label_font_style,
      fontSize: this.label_font_size,
      text: xLabel
    };
  }
  if (transitionDuration) {
    renderXAxisOptions.transitionDuration = transitionDuration;
  }
  XAxis.renderXAxis(this.vis[0], xAxis, renderXAxisOptions);
  if (this.isXAxisFixed === true) {
    const renderXAxisFixedOptions = {};
    if (xLabel !== undefined) {
      renderXAxisFixedOptions.label = {
        fontStyle: this.label_font_style,
        fontSize: this.label_font_size,
        text: xLabel
      };
    }
    if (transitionDuration) {
      renderXAxisFixedOptions.transitionDuration = transitionDuration;
    }
    XAxis.renderXAxis(this.$xAxisWrapper, xAxis, renderXAxisFixedOptions);
  }
}

export function renderYAxis (yScale, yAxis, yLabel, options = {}) {
  const renderYAxisOptions = { ...options };
  const xDomain = this.xScale.domain();
  if (this.isWrapY === true) {
    renderYAxisOptions.ellipsis = {
      width: xDomain[0] >= 0 ? this.margin.left : this.margin.right
    };
  }
  if (yLabel !== undefined) {
    const x = renderYAxisOptions.translate.x
      ? this.margin.left + renderYAxisOptions.translate.x
      : this.margin.left;
    renderYAxisOptions.label = {
      fontStyle: this.label_font_style,
      fontSize: this.label_font_size,
      text: yLabel,
      position: {
        // x: xDomain[0] < 0
        //   ? -(this.margin.left + renderYAxisOptions.translate.x)
        //   : this.margin.right
        x: -x
      },
      margin: this.margin
    };
  }
  YAxis.renderYAxis(this.vis[0], yAxis, renderYAxisOptions);

  if (this.hasYAxisGrid === true) {
    const yGridPosition = { x: 0, x2: undefined };
    if (this.isYAxisGridFitXAxis === true) {
      // yGridPosition.x = this.xScale(xDomain[0]);
      yGridPosition.x = -(this.margin.left - (yLabel !== undefined ? this.label_font_size : 0));
      yGridPosition.x2 = this.xScale(xDomain.at(-1));
    }
    YAxis.renderYGrid(this.vis[0], yScale, { position: yGridPosition });
  }
}
